export enum ExternalProviderEnum {
  WoltersKluwer = 'wolters_kluwer',
}

export interface WoltersKluwerSettings {
  wk_ovidgroup: string;
  wk_customer_name: string;
  wk_customer_id: string;
  wk_orionid: string;
}

export type ExternalAccountSettings = WoltersKluwerSettings;

export interface ExternalAccountModel {
  is_external_account: boolean;
  external_account_provider?: ExternalProviderEnum;
  external_account_settings?: ExternalAccountSettings;
}
